interface RouteParams {
  id: string;
  name: string;
  type: string;
}

export const getQueryParamsFromPath = ({ id, name, type }: RouteParams) => {
  let query = {};
  if (type === "popular") {
    query = { ...query, order: "desc", sortOrder: "popularity" };
  }

  if (type === "featured") {
    query = { ...query, featured: true };
  }

  if (type === "sale" || type === "on_sale") {
    query = { ...query, saleType: true };
  }

  if (id !== "0") {
    query = { ...query, categoryId: id };
  }

  return query;
};

export const replaceEmbed = (str: string) => {
  // @ts-ignore
  return str.replace(/\[embed\](.+?)\[\/embed\]/gimu, `<embed src="$1"/>`);
};
